import { scenariosDict } from '../support/dictionaries';
import manifest from '../support/transitionManifest.json';

const base = process.env.PUBLIC_URL || '';
export const playbackCatalog = {
    ...scenariosDict,
    ...Object.fromEntries(Object.entries(manifest.assets).map(([key, asset]) =>
        [key, `${base}/transitions/${asset.file}`])),
};
export const playbackKeysByUrl = new Map(Object.entries(playbackCatalog).map(([key, url]) => [url, key]));
export const isPlaybackKey = key => typeof key === 'string'
    && Object.prototype.hasOwnProperty.call(playbackCatalog, key);
export const isTransitionKey = key => Object.prototype.hasOwnProperty.call(manifest.assets, key);
export const transitionTarget = key => manifest.assets[key]?.to || null;

export function planNextMedia(currentKey, nextKey, ended) {
    const bridge = ended && manifest.pairs[`${currentKey}>${nextKey}`];
    return bridge
        ? { key: bridge, target: nextKey }
        : { key: nextKey, target: null };
}
